import React, { useEffect, useState } from "react";

import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import request from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { getSalestargetDetailByMaster } from "../grphql";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import TableComponent from "../../../components/GridTable/TableComponent";

const ManagerTargetTabel = () => {
  const [data, setData] = useState([]);
  const { currentUser } = useAuth();
  const navigate=useNavigate()
  const isUser = currentUser?.role;


  const handleEmployeeView=()=>{
    navigate(`/SalesTarget/showTarget?${currentUser?.id}`);
  }
  const productListTable = {
    columns: [
      {
        label: "S.No.",
        field: "sno",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },

      {
        label: "Employee Name",
        field: "user",
        name: "Product Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Year Target",
        field: "salesTarget",
        name: "Product ID",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Target",
        field: "targetAmount",
        name: "Product ID",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Action",
        field: "action",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.map((item, index) => ({
      sno: index + 1,
      id: item.id,
      user: item.user.username,
      salesTarget: item.salesTarget.financialYear,
      targetAmount: item.targetAmount,
      action:
      (
        <>
   
         <Tooltip title="view" onClick={()=>handleEmployeeView()} sx={{cursor:'pointer'}}>

            <RemoveRedEyeIcon />
         </Tooltip>

          
        
        </>
      )
     
    })),
  };

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const res = await request(BASEURL, getSalestargetDetailByMaster, {
          id: currentUser?.id,
        });
      
        setData(res?.getSalestargetDetailByMaster);
      } catch (err) {}
    };

    fetchdata();
  }, []);

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }

  const onDeleteALL=()=>
      {
        console.log("id-DELE")
      }
  const onDelete=(id)=>
        {
          console.log("id-d",id)
        }

  return (
    <>
    <TableComponent
    columns={productListTable.columns}
    rowsData={productListTable.rows}
    styles={{ paper: { padding: '16px' } }}
    head="Manager Target List"
    actions={false}
    checked={false}
    view={true}
    showAdd = {false}
    onCheck={onCheck}
    // onEdit={onOpportunityTypeListClick}
    onDelete={onDelete}
    // onView={onOpportunityTypeListClick}
    onDeleteALL={onDeleteALL}
    // addList={() => handleNewOpportunityType()}
    />
    {/* <MaterialDataGrid
      rows={productListTable.rows}
      columns={productListTable.columns}
      //  onRowClick={onLeadAndProscpectClick}
      // onRowClick={(data)=>handleRowClick(data)}
    /> */}
    </>
  );
};

export default ManagerTargetTabel;
